import http from "./httpService";
import auth from "./authService";

function supplierStoreUrl(id) {
  if (id)
    return `/v1/companies/${auth.getCurrentUser().company_id}/expenses/${id}`;
  else return `/v1/companies/${auth.getCurrentUser().company_id}/expenses`;
}

export function getAll() {
  return http.get(supplierStoreUrl());
}

export function deleteSingle(supplierId) {
  return http.delete(supplierStoreUrl(supplierId));
}

export function saveSingle(supplier) {
  return http.post(supplierStoreUrl(), supplier);
}

export function updateSingle(supplier,expenseid) {
  return http.post(supplierStoreUrl(expenseid), supplier);
}

export function updateSingleStatus(supplier) {
  return http.get(
    `/v1/companies/${auth.getCurrentUser().company_id}/expenses/${
      supplier.id
    }/status`
  );
}

export function getSingle(supplierId) {
  return http.get(supplierStoreUrl(supplierId));
}
